export const title = 'Something went wrong';
export const subTitle = 'Please try again or contact support';
